import { SolicitacaoArquivos, LabelTipoSolicitacaoArquivo } from './../../../model/solicitacao-arquivos.model';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { SolicitacaoArquivosService } from '../solicitacao-arquivos.service';
import { FileUtilsService } from 'src/app/shared/file-utils.service';


@Component({
    selector: 'app-solicitacao-arquivos-listagem',
    templateUrl: './solicitacao-arquivos.listagem.component.html',
    styleUrls: ['./solicitacao-arquivos.listagem.scss'],
    standalone: false
})
export class SolicitacaoArquivosListagemComponent implements OnInit, OnChanges {

  @Input() public arquivo: SolicitacaoArquivos[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Input() public formatoArquivo: string;
  public opcoesPaginacao: number[];
  public listaArquivo: any[];
  public countArquivo: number;
  public labelsSolicitacaoArquivo = LabelTipoSolicitacaoArquivo;

  constructor(private solicitacaoArquivosService: SolicitacaoArquivosService,
              private fileUtils: FileUtilsService,) {


  }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacao = {
      page: 1,
      pageSize: this.opcoesPaginacao[0]
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.navegar(this.atributosPaginacao);
  }

  public mudancaPagina(novaPagina: EntityPagedRequestParameters) {

    this.atributosPaginacao = novaPagina;
    this.navegar(this.atributosPaginacao);
  }

  public navegar(pesq: EntityPagedRequestParameters) {

    let posInicial: number, posFinal: number;

    posInicial = (pesq.page-1) * pesq.pageSize;
    posFinal = posInicial + pesq.pageSize;

    if (posFinal > this.arquivo.length) {
      posFinal = this.arquivo.length;
    }

    this.listaArquivo = this.arquivo.slice(posInicial, posFinal);
    this.countArquivo = this.arquivo.length;
  }

  public buscaConteudo(id: number) {
    this.formatoArquivo == 'csv'
    this.solicitacaoArquivosService.buscarConteudoSolicitacao(id).subscribe((conteudoArquivo) => {
      this.fileUtils.exportarArquivo('Arquivo_' + id + '.csv',
        conteudoArquivo, FileUtilsService.TEXT_CSV);
    })
  }

  public labelSolicitacaoArquivo(item) {
    return this.labelsSolicitacaoArquivo.get(item);
  }

}
